"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_router_dom_1 = require("react-router-dom");

var react_jss_1 = __importDefault(require("react-jss"));

var color_1 = __importDefault(require("color"));

var style = function style(theme) {
  return {
    page: {
      background: theme.paperBackground,
      padding: 15,
      borderRadius: 5,
      color: color_1.default(theme.paperBackground).isLight() ? '#333333' : '#EEEEEE'
    },
    titleBar: {
      display: 'flex',
      borderBottom: '1px solid rgba(0, 0, 0, .1)',
      marginBottom: 5,
      height: 64
    },
    titleText: {
      fontSize: 22,
      textAlign: 'center',
      flex: '1 0',
      lineHeight: '64px'
    },
    corner: {
      width: 64
    },
    close: {
      fontSize: 54,
      textDecoration: 'none',
      display: 'block',
      textAlign: 'center'
    }
  };
};

var Page = function Page(_a) {
  var children = _a.children,
      title = _a.title,
      classes = _a.classes;
  return react_1.default.createElement("div", {
    className: classes.page
  }, title && react_1.default.createElement("div", {
    className: classes.titleBar
  }, react_1.default.createElement("div", {
    className: classes.corner
  }), react_1.default.createElement("div", {
    className: classes.titleText
  }, title), react_1.default.createElement("div", {
    className: classes.corner
  }, react_1.default.createElement(react_router_dom_1.Link, {
    to: "/",
    className: classes.close
  }, "\xD7"))), react_1.default.createElement("div", null, children));
};

exports.default = react_jss_1.default(style)(Page);